<template>
  <span>
    <a @click.stop="ui.showElement = true">
      <slot name="trigger">Modal</slot>
    </a>
    <transition :name="animateClass">
      <div
        v-if="ui.showElement"
        class="Modal-mask"
        @click.prevent="closeGobalModal"
      >
        <div
          :class="['Modal-wrapper', modalClass, extraClasses]"
          @click.stop
        >
          <div class="Modal-container">
            <button
              class="Modal-closeIcon"
              @click="closeGobalModal"
            >
              <span class="Icon Icon-times" />
            </button>
            <div class="Modal-header">
              <slot name="header">
                <h2>default header</h2>
              </slot>
            </div>
            <div class="Modal-body">
              <slot name="body">
                <p>default body</p>
              </slot>
            </div>

            <div class="Modal-footer">
              <div :class="['Buttons', {'Buttons--single': !showCancelButton}]">
                <div
                  v-if="showCancelButton"
                  class="u-floatLeft"
                >
                  <button
                    class="Button Button--grey"
                    @click="closeGobalModal"
                  >
                    {{ cancelText }}
                  </button>
                </div>
                <div class="u-floatRight">
                  <slot name="footer">
                    <button
                      class="Button Button--green"
                    >
                      Button slot
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </span>
</template>
<script>
import globalDismissOverlaysMixin from '../../mixins/global-dismiss-overlay-mixin';

export default {

  name: 'RmpModal',
  mixins: [globalDismissOverlaysMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    extraClasses: {
      type: String,
      default: null,
    },
    modalStyle: {
      type: String,
      default: 'Modal',
    },
    showCancelButton: {
      default: false,
      type: Boolean,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
  },

  data() {
    return {
      ui: {
        showElement: false,
      },
    };
  },
  computed: {
    animateClass() {
      return this.modalStyle === 'bottom-sheet' ? 'BottomSheet' : 'Modal';
    },
    modalClass() {
      return this.modalStyle === 'bottom-sheet' ? 'Modal--bottomSheet' : 'Modal--center';
    },
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(val) {
        if (val && !this.ui.showElement) {
          this.ui.showElement = val;
        }
      },
    },
  },
  methods: {
    closeGobalModal() {
      this.ui.showElement = false;
      if (this.show) {
        this.$bus.$emit('close');
      }
    },
  },
};
</script>

<style lang="less">
  .Modal-container {
    word-break: break-word;
    word-break: normal;
  }
  .Buttons{
    width: 100%;
  }
  .Buttons--full{
    .Button{
      width: 100%;
    }
  }
</style>
